module.exports = __webpack_public_path__ + "static/media/emily-poon.9ff3fd67.png";